


<!--start header-->

<header class="head d-flex justify-content-center align-items-center">

  <div class="head-caption text-center">
   <h1>CONTACT</h1>
   <p>Tomato is a delicious restaurant website template</p>
  </div>

</header>

<!--end header-->

<!--start section contacts-->

<section class="container py-5 contacts">
  <div class="row">

   <div class="col-md-6 mb-4">

     <div class="contacts-content">
       <h3 class="text-dark">ADDRESS</h3>
       
       <div class="i-cont">
        <p><i class="fas fa-map-marker-alt pr-2"></i>
          28 Seventh Avenue, Neew York, 10014</p>
         <p><i class="fas fa-phone-alt pr-2"></i>
           Phone: (415) 124-5678</p>
         <p><i class="fas fa-envelope pr-2"></i>
           support@restaurant.com</p>
      </div>
     </div>

     <div class="contacts-content-o pt-4">
      <h3 class="text-dark pb-2">
        WORKING HOURS</h3>
        <p>10:00 am to 11:00 pm on Weekdays</p>
        <p class="position-relative">11:00 am to 11:30 pm on Weekends </p>
      
    </div>

    <div class="contacts-content pt-2 text-white">
      <h3 class="text-dark pb-2">FOLLOW US</h3>
        <div class="social-icon ">
          <i class="fab fa-facebook-f p-3"></i>
            <i class="fab fa-twitter p-3 ml-2"></i>
            <i class="fab fa-instagram p-3 ml-2"></i>
            <i class="fab fa-dribbble p-3 ml-2"></i>
            
           
        </div>
    </div>


   </div>

   <div class="col-md-6 contacts-caption">
   

      
      
        <div class="form-group">
         
          <input type="text" name="uname" class="form-control input-cont border-0" placeholder="Full Name">
          
        </div>
  
      
      
      
        <div class="form-group">
          
          <input type="email" name="uemail" class="form-control input-cont border-0" placeholder=" Email  Address">
        </div>
  
    

      
      
        <div class="form-group">
         
          <input  name="udata" class="form-control input-cont border-0" placeholder="Pick a data" >
         
        </div>
        <div class="form-group">
         
          <textarea class="input-cont" placeholder="message "></textarea>
         
        </div>

        <div class="form-group">
         
          <button class="btn-default border-0 input-cont text-dark">SEND MESSAGE</button>
         
        </div>
  
      
      
  
   </div>

  </div>
</section>

<!--end section contacts-->


<!--start section insta-->
<section class="bg">

  <div class="container py-4">

   <div class="row insta-caption">
      <div class="col-md-3 sub-caption">
          <p>SUBSCRIBE</p>
      </div>
      <div class="col-md-8">
       <p class="text-muted p">Get updates about new dishes and upcoming events</p>
   </div>
     
     </div>
     <div class="registers d-flex justify-content-end pb-4">
       <input class="inpt-caption mr-4" type="email" placeholder=" Your Email Address ">
       <button type="submit" class="register"><i class="fas fa-chevron-right fa-1x"></i></button>
     </div>

  </div>
</section>

<!--end section insta-->
